export var MooringDepartureLineTypeContent;
(function (MooringDepartureLineTypeContent) {
    MooringDepartureLineTypeContent["SingleUp"] = "single up";
    MooringDepartureLineTypeContent["AllLinesCastOff"] = "all lines cast off";
    MooringDepartureLineTypeContent["AllLinesOnDeck"] = "all lines on deck";
})(MooringDepartureLineTypeContent || (MooringDepartureLineTypeContent = {}));
//# sourceMappingURL=MooringBeforeDepartureContent.js.map